// helpers ----------------

function getLineBreakChar(string) {
  // no need to check first-character
  const indexOfLF = string.indexOf('\n', 1);

  if (indexOfLF === -1) {
      if (string.indexOf('\r') !== -1) return '\r';
      return '\n';
  }

  if (string[indexOfLF - 1] === '\r') return '\r\n';
  return '\n';
}

function removeDoubleLineBreakChars(string) {
  // return string.replace("\n\n", "\n");
  return string.replace(/(\r\n|\r|\n){2,}/g, '$1\n');
}

// core --------------------------
function editorPastePlain(input) {
  // temporary element
  let output = document.createElement('div');

  // is different on Windows and Unix systems
  const lineChar = getLineBreakChar(input);

  // use documentFragment for better performance
  let fragment = document.createDocumentFragment();

  // split to paragraph elements
  const splitted = input.split(lineChar);
  splitted.forEach(element => {
    if (element.length) {
      var p = document.createElement('p');
      p.textContent = removeDoubleLineBreakChars(element);
      fragment.appendChild(p);
    }
  });

  // swap from fragment to base element so execCommand can use it
  output.appendChild(fragment);
  return output.innerHTML;
}

export { editorPastePlain }